import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LoadingButton } from '@sorare/core/src/atoms/buttons/LoadingButton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import type { QuickPlayTutorialDialogType } from '#src/components/quickPlay/QuickPlayTutorialDialog/types.ts';

const Root = styled(Vertical)`
  justify-self: center;
  width: 100%;

  @media ${tabletAndAbove} {
    width: auto;
  }
`;
const ButtonWrapper = styled.div`
  align-self: stretch;
  & > * {
    width: 100%;
  }
`;

type Props = {
  onSelect: (type: QuickPlayTutorialDialogType) => void;
  selectedType: QuickPlayTutorialDialogType;
  onContinue: () => void;
  loading: boolean;
};
export const QuickPlayTutorialFooter = ({
  onSelect,
  selectedType,
  onContinue,
  loading,
}: Props) => {
  return (
    <Root center gap={2}>
      <TabBar value={selectedType} variant="primary">
        <Tab value="quickPlay" onClick={() => onSelect('quickPlay')}>
          <FormattedMessage {...glossary.quickPlay} />
        </Tab>
        <Tab value="targets" onClick={() => onSelect('targets')}>
          <FormattedMessage
            id="IntroducingQuickPlayDialog.targets"
            defaultMessage="Targets"
          />
        </Tab>
        <Tab value="scoring" onClick={() => onSelect('scoring')}>
          <FormattedMessage
            id="IntroducingQuickPlayDialog.scoring"
            defaultMessage="Scoring"
          />
        </Tab>
      </TabBar>
      <ButtonWrapper>
        <LoadingButton
          loading={loading}
          size="large"
          color="primary"
          onClick={onContinue}
        >
          <FormattedMessage {...glossary.playNow} />
        </LoadingButton>
      </ButtonWrapper>
    </Root>
  );
};
